<template>
  <v-row>
    <v-col cols="12">
      <v-card flat>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="10">
              <PrimaryFiltersVT
                :list_filters="page_content.tabs"
                @filter_update="update_current_tab($event)"
                :current_tab="current_tab"
              ></PrimaryFiltersVT>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <v-btn small color="vtblue" @click="open_new_popup" dark>
                {{ $t("common.labels.addNewAlert") }}
                <v-icon class="pl-2" small>mdi-bell-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="mx-3 py-4" v-if="current_tab == 'ActiveAlerts'" no-gutters>
            <v-col cols="12">
              <DataTableVT
                :headers="page_content.active_alerts_table"
                :items_list="comp_active_alerts"
                sort_by="AlertID"
                item_key="ActiveAlertID"
                no_export="true"
                print="false"
                :loading="is_loading"
              /> </v-col
          ></v-row>
          <v-row class="mx-3 py-4" v-if="current_tab == 'ManageAlerts'" no-gutters>
            <v-col cols="12">
              <DataTableVT
                :headers="page_content.alerts_table"
                :items_list="comp_alerts"
                sort_by="AlertID"
                item_key="AlertID"
                no_export="true"
                print="false"
                @action="modify_alert($event)"
                :loading="is_loading"
              /> </v-col
          ></v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-overlay class="layering" :value="dialog">
      <v-card
        :light="!this.$vuetify.theme.dark"
        class="backgroundWhite"
        style="width: 80vw; max-height: 80vh; overflow: auto"
      >
        <div class="close-btn">
          <v-btn right @click="closeDialog" outlined color="primaryGrey" class="py-4" x-small>
            <v-icon small color="primaryGrey">mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="pa-4" style="overflow: auto; height: 100%">
          <v-row v-if="dialog_type == 'recipients'" class="mx-3 py-4" no-gutters>
            <v-col cols="12" no-gutters>
              <div class="text-h6 mb-3">
                {{ $t("common.words.recepients") }}
              </div>
              <div
                class="d-flex"
                v-for="(recipient, indx) in recipients_list"
                :key="`${recipient.AlertRecipientID}_${indx}`"
              >
                <div class="width-30">
                  <span>{{ recipient.RecipientName }}</span
                  ><span class="text-caption primary--text">({{ recipient.RecipientEmail }})</span>
                </div>
                <div>
                  <v-icon @click="delete_recipient(recipient)" small>mdi-trash-can</v-icon>
                </div>
              </div>
              <div class="d-flex mt-4">
                <v-text-field
                  class="mr-4"
                  dense
                  color="primaryDark"
                  v-model="new_recipient.RecipientName"
                  label="Name"
                ></v-text-field>
                <v-text-field
                  class="mr-4"
                  dense
                  color="primaryDark"
                  v-model="new_recipient.RecipientEmail"
                  label="Email"
                ></v-text-field>
                <v-btn
                  small
                  class="mr-4 bold"
                  :disabled="validate_recipient"
                  dense
                  color="primary"
                  @click="add_recipient(new_recipient)"
                  >{{ $t("common.labels.addNewRecepient") }}</v-btn
                >
                <v-btn small class="mr-4 bold" dense outlined @click="clear">{{ $t("common.words.clear") }}</v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row v-else class="mx-3" no-gutters>
            <v-col cols="12">
              <v-form ref="new_alert_form" v-model="valid">
                <v-row no-gutters class="pa-2">
                  <v-col cols="12" class="text-h6 pr-8"
                    ><span class="text-capitalize">{{ this.dialog_type }}</span> {{ $t("common.words.alert") }}</v-col
                  >
                  <v-col v-if="new_alert.AlertID" cols="12" class="primaryGrey--text pr-8 pb-2"
                    ><span class="text-capitalize">Alert ID :</span> {{ new_alert.AlertID }}</v-col
                  >
                  <v-col cols="6" class="pr-8 pb-1 pt-4">
                    <v-select
                      dense
                      v-if="!isPowerdata"
                      color="primaryDark"
                      v-model="new_alert.LocationCategory"
                      :disabled="!!new_alert.LocationID"
                      :items="page_content.LocationCategory"
                      label="POI Category"
                    ></v-select>
                    <v-select
                      dense
                      v-else
                      color="primaryDark"
                      v-model="new_alert.DeviceType"
                      :disabled="!!new_alert.DeviceID"
                      :items="page_content.DeviceType"
                      :label="device_type_label"
                    ></v-select>
                  </v-col>
                  <v-col cols="6" class="pr-8 pb-1 pt-4">
                    <v-autocomplete
                      dense
                      color="primaryDark"
                      v-if="!isPowerdata"
                      v-model="new_alert.LocationID"
                      :disabled="!!new_alert.LocationCategory"
                      :items="poi_list"
                      item-text="FullName"
                      label="POI"
                      item-value="LocationID"
                    ></v-autocomplete>
                    <v-autocomplete
                      dense
                      color="primaryDark"
                      v-else
                      v-model="new_alert.DeviceID"
                      :disabled="!!new_alert.DeviceType"
                      :items="assets"
                      item-text="label"
                      :label="device_label"
                      item-value="DeviceID"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="6" class="pr-8 py-1">
                    <v-select
                      dense
                      color="primaryDark"
                      v-model="new_alert.TriggerField"
                      :items="page_content.TriggerField"
                      :rules="requiredRule"
                      required
                      :label="trigger_field_label"
                      item-text="label"
                      item-value="value"
                    ></v-select>
                  </v-col>
                  <v-col cols="6" class="pr-8 py-1">
                    <v-select
                      dense
                      color="primaryDark"
                      disabled
                      v-if="new_alert.TriggerField == 'Alarm'"
                      v-model="new_alert.TriggerOperator"
                      :items="page_content.TriggerOperator"
                      :label="trigger_operator_label"
                    ></v-select>
                    <v-select
                      v-else
                      dense
                      color="primaryDark"
                      v-model="new_alert.TriggerOperator"
                      :items="page_content.TriggerOperator"
                      :rules="requiredRule"
                      required
                      :label="trigger_operator_label"
                    ></v-select>
                  </v-col>
                  <v-col cols="6" class="pr-8 py-1">
                    <v-text-field
                      dense
                      v-if="new_alert.TriggerField == 'Alarm'"
                      disabled
                      color="primaryDark"
                      v-model="new_alert.TriggerValue"
                      :label="trigger_value_label"
                    ></v-text-field>
                    <v-text-field
                      v-else
                      dense
                      color="primaryDark"
                      v-model="new_alert.TriggerValue"
                      :label="`Trigger Value ${new_alert.TriggerField == 'FlowRate' ? '(%)' : ''}`"
                      :rules="numberRule([0, 500], true)"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-row>
                      <v-spacer></v-spacer>
                      <v-col cols="auto">
                        <v-btn dense outlined class="mr-2 bold" @click="cancel_new_alert">{{
                          $t("common.words.cancel")
                        }}</v-btn>
                        <v-btn dense color="primary" @click="validate_new_alert()" class="bold" :disabled="!valid">{{
                          $t("common.words.save")
                        }}</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-overlay>
    <ConfirmationDialogVT
      v-if="showDeleteDialog"
      :id="dialog_alert_id"
      :buttonText="'Delete'"
      :text="'This alert will be deleted!'"
      @confirm_action="delete_alert"
      @closeDialog="showDeleteDialog = false"
    />
    <v-snackbar color="borderDark" v-model="snackbar" timeout="2000">{{ error_message }}</v-snackbar>
  </v-row>
</template>

<script>
import PrimaryFiltersVT from "../components/PrimaryFiltersVT";
import DataTableVT from "../components/DataTableVT";
import ConfirmationDialogVT from "./ConfirmationDialogVT.vue";
import { axios_get, axios_put, axios_delete, axios_post } from "../services/vt_service";
import { tracking } from "../services/tracking";
import { trafo } from "../services/powerdata";

export default {
  name: "AlertsTemplate",
  props: {
    page_content: Object,
    isPowerdata: Boolean,
  },
  components: { DataTableVT, PrimaryFiltersVT, ConfirmationDialogVT },
  data: function () {
    return {
      device_type_label: this.$t("components.AlertsTemplate.labels.deviceType"),
      trigger_field_label: this.$t("components.AlertsTemplate.labels.triggerField"),
      trigger_value_label: this.$t("components.AlertsTemplate.labels.triggerValue"),
      device_label: this.$t("components.AlertsTemplate.labels.device"),
      trigger_operator_label: this.$t("components.AlertsTemplate.labels.triggerOperator"),
      showDeleteDialog: false,
      dialog_type: "",
      error_message: "",
      alerts: [],
      active_alerts: [],
      current_tab: "ActiveAlerts",
      dialog: false,
      new_alert: {},
      recipients_list: null,
      new_recipient: {},
      valid: false,
      snackbar: false,
      alert_id: null,
      dialog_alert_id: null,
      api_base_url: null,
      location_categories: null,
      requiredRule: [(v) => !!v || this.$t("common.labels.thisFieldIsRequired")],
      is_loading: false,
    };
  },
  created() {
    this.api_base_url = this.isPowerdata ? "/api/alert/powerdata/" : "/api/alert/";
  },
  mounted() {
    this.is_loading = true;
    // this.$store.commit("update_page_title", "Alerts");
    this.get_alerts_data();
    this.get_active_alerts_data();
    if (!this.isPowerdata) {
      this.get_LocationCategory();
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.deviceId = null;
    },
    open_new_popup() {
      this.dialog_type = "new";
      this.new_alert = {};
      this.dialog = true;
      this.valid = false;
    },
    async get_alerts_data() {
      this.network_error = false;
      let api_base_url = this.isPowerdata ? trafo.get_alerts_data : tracking.get_alerts_data;
      let response = await axios_get(api_base_url);
      this.alerts = response[0];
      this.is_loading = false;
    },
    async get_recipients_list(id) {
      this.network_error = false;
      let response = await axios_get(tracking.get_recipients_list, { id });
      this.recipients_list = response[0];
    },
    update_alert: async function () {
      this.network_error = false;
      let temp = JSON.parse(JSON.stringify(this.new_alert));
      if (temp.TriggerField == "FlowRate") temp.TriggerValue = temp.TriggerValue / 100;
      let api_base_url = this.isPowerdata ? trafo.update_alert : tracking.update_alert;
      await axios_put(api_base_url, { id: this.alert_id }, temp);
      this.error_message = "Alert details updated successfully!";
      this.snackbar = true;
      this.get_alerts_data();
      this.dialog = false;
      this.dialog_type = "";
      this.current_tab = "ManageAlerts";
    },
    async get_LocationCategory() {
      this.network_error = false;
      let response = await axios_get(tracking.get_LocationCategory);
      this.location_categories = response
        .map((elem) => {
          if (elem.LocationCategory) return elem.LocationCategory;
        })
        .filter((elem) => {
          if (elem) return elem;
        });
      // this.page_content.LocationCategory = this.location_categories;
    },
    add_recipient: async function (recipient) {
      this.network_error = false;
      await axios_post(tracking.add_recipient, recipient, { id: this.alert_id });
      this.error_message = "New recipient added successfully!";
      this.snackbar = true;
      this.clear();
      this.get_recipients_list(this.alert_id);
    },
    delete_recipient: async function (recipient) {
      this.network_error = false;
      await axios_delete(tracking.delete_recipient, {
        alert_id: this.alert_id,
        recipient_id: recipient.AlertRecipientID,
      });
      this.error_message = "Deleted successfully!";
      this.snackbar = true;
      this.get_recipients_list(this.alert_id);
    },
    async get_active_alerts_data() {
      this.network_error = false;
      let api_base_url = this.isPowerdata ? trafo.get_active_alerts : tracking.get_active_alerts;
      let response = await axios_get(api_base_url);
      this.active_alerts = response[0];
    },
    async add_alert() {
      this.network_error = false;
      let temp = JSON.parse(JSON.stringify(this.new_alert));
      if (temp.TriggerField == "FlowRate") temp.TriggerValue = temp.TriggerValue / 100;
      if (temp.TriggerField == "Alarm") {
        temp.TriggerValue = 0;
        temp.TriggerOperator = "";
      }
      let api_base_url = this.isPowerdata ? trafo.add_alert : tracking.add_alert;
      await axios_post(api_base_url, temp);
      this.error_message = "Alert added successfully!";
      this.snackbar = true;
      this.get_alerts_data();
      this.dialog = false;
      this.dialog_type = "";
      this.current_tab = "ManageAlerts";
    },
    clear: function () {
      this.new_recipient = {
        RecipientName: "",
        RecipientEmail: "",
      };
    },
    modify_alert(obj) {
      if (obj.action == "Delete") {
        this.dialog_alert_id = obj.item.AlertID;
        this.showDeleteDialog = true;
      } else if (obj.action == "ManageRecipients") {
        this.open_recipients_popup(obj.item);
      } else {
        this.open_edit_popup(obj.item);
      }
    },
    open_edit_popup(alert) {
      this.alert_id = alert.AlertID;
      this.dialog_type = "edit";
      this.dialog = true;
      this.new_alert = JSON.parse(JSON.stringify(alert));
    },
    open_recipients_popup(alert) {
      this.alert_id = alert.AlertID;
      this.get_recipients_list(alert.AlertID);
      this.dialog = true;
      this.dialog_type = "recipients";
    },
    async delete_alert(payload) {
      const { id } = payload;
      this.network_error = false;
      await axios_delete(tracking.delete_alert, {
        id,
      });
      this.error_message = "Alert deleted successfully!";
      this.snackbar = true;
      this.get_alerts_data();
    },
    numberRule: function (digits, isRequired) {
      if (typeof digits == "number") {
        return isRequired
          ? [(v) => !!v || "This field is required", (v) => (v && v <= digits) || `Must be less than ${digits}`]
          : [(v) => !v || (v && v <= digits) || `Must be less than ${digits}`];
      } else {
        return isRequired
          ? [
              (v) => !!v || "This field is required",
              (v) =>
                (v && v <= digits[1] && v >= digits[0]) ||
                `Must be less than ${digits[1]} and greater than ${digits[0]}`,
            ]
          : [(v) => !v || (v && v <= digits[1] && v >= digits[0]) || `Must be less than ${digits}`];
      }
    },
    update_current_tab(val) {
      this.current_tab = val;
    },
    cancel_new_alert() {
      this.dialog_type = "";
      (this.dialog = ""), (this.new_alert = {});
    },
    validate_new_alert() {
      if (this.$refs.new_alert_form.validate()) {
        this.is_loading = true;
        this.dialog_type == "edit" ? this.update_alert() : this.add_alert();
      }
    },
  },
  computed: {
    poi_list: function () {
      let locations = this.$store.state.locations ? JSON.parse(JSON.stringify(this.$store.state.locations)) : [];
      return locations;
    },
    poi_obj: function () {
      let temp =
        this.poi_list && this.poi_list.length > 0
          ? this.poi_list.reduce(function (map, obj) {
              map[obj.LocationID] = obj;
              return map;
            }, {})
          : {};
      return temp;
    },
    assets: function () {
      let temp = this.$store.state.devices
        ? this.$store.state.devices.map((elem) => {
            elem.label = `${elem.DeviceID} - ${elem.DeviceName}/${elem.SerialNumber}/${elem.PowerRating}/${elem.AssetID}`;
            return elem;
          })
        : [];
      return temp;
    },
    validate_recipient() {
      let pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return !(this.new_recipient.RecipientName && pattern.test(this.new_recipient.RecipientEmail));
    },
    comp_alerts: function () {
      let alerts = this.alerts;
      if (!this.isPowerdata) {
        alerts =
          this.alerts &&
          this.poi_obj &&
          Object.keys(this.poi_obj).length > 0 &&
          this.alerts.filter((elem) => {
            return elem.LocationID ? !!this.poi_obj[elem.LocationID] : true;
          });
      }
      return alerts.map((elem) => {
        elem.FullName = elem.LocationID ? this.poi_obj[elem.LocationID].FullName : "";
        elem.TriggerValue = elem.TriggerField == "FlowRate" ? elem.TriggerValue * 100 : elem.TriggerValue;
        return elem;
      });
    },
    comp_active_alerts: function () {
      return (
        this.active_alerts &&
        this.active_alerts.map((elem) => {
          if (elem.TriggerField == "FlowRate") {
            elem.TriggerValue = elem.TriggerValue * 100;
            elem.ActualValue = elem.ActualValue * 100;
          }
          return elem;
        })
      );
    },
  },
};
</script>
<style scoped lang="scss">
.container-width {
  width: 794px;
  overflow-x: visible;
  overflow-y: auto;

  ::v-deep a {
    color: #0581c6 !important;
  }
}
.close-btn {
  position: absolute;
  right: 0;
  z-index: 9;
  padding: 1em;
}
div.width-30 {
  min-width: 30%;
}
</style>
